import { render, staticRenderFns } from "./Mensagem.vue?vue&type=template&id=d33c62de&scoped=true"
import script from "./Mensagem.vue?vue&type=script&lang=js"
export * from "./Mensagem.vue?vue&type=script&lang=js"
import style0 from "./Mensagem.vue?vue&type=style&index=0&id=d33c62de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33c62de",
  null
  
)

export default component.exports